import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { PhaserGame } from '../phaser/PhaserGame';
import { BaseLayout } from '../components';

const GamePage: React.FC = () => {
  const gameRef = useRef<HTMLDivElement>(null);
  const phaserGameRef = useRef<PhaserGame | null>(null);

  useEffect(() => {
    if (gameRef.current && !phaserGameRef.current) {
      phaserGameRef.current = new PhaserGame(gameRef.current);
    }

    return () => {
      if (phaserGameRef.current) {
        phaserGameRef.current.destroy();
        phaserGameRef.current = null;
      }
    };
  }, []);

  return (
    <BaseLayout className="game-page">
      <header className="safe-area-top" style={{ padding: '20px', display: 'flex', alignItems: 'center', gap: '15px' }}>
        <Link to="/">
          <button className="touch-button" style={{ 
            backgroundColor: '#3b82f6', 
            color: 'white', 
            border: 'none', 
            borderRadius: '8px',
            fontSize: '16px'
          }}>
            ← Back to Home
          </button>
        </Link>
        <h2 style={{ color: 'white', margin: 0 }}>Game Arena</h2>
      </header>
      <div ref={gameRef} className="game-container" style={{ flex: 1 }} />
    </BaseLayout>
  );
};

export default GamePage;
